import { getBranches } from "@aitisal/sdk/restaurant";
import { IconSearch } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import BranchCard from "../../../components/BranchCard";
import { MapComponent } from "../../../components/Map/MapComponent";
import { Input } from "../../../components/ui/Input";
import { Skeleton } from "../../../components/ui/Skeleton";
import { useMediaQuery } from "../../../hooks/useMediaQuery";
import { useSession } from "../../../stores/sessionStore";
import { ThemeSlot } from "../../../themes/slots";

export const Route = createFileRoute("/pickup/map" as any)({
  component: () => {
    return (
      <>
        <ThemeSlot slot="header" isMenu={true} isAddressRequired={true} />
        <RouteComponent />
        {/* <Footer /> */}
      </>
    );
  },
});

function RouteComponent() {
  const { pointOfOrder } = useSession();

  const { data: restaurants, isLoading: isRestaurantsLoading } = useQuery({
    queryKey: ["restaurants"],
    queryFn: async () => {
      const response: any = await getBranches(pointOfOrder?.brandId);
      return response?.data;
    },
    enabled: Boolean(pointOfOrder?.brandId),
  });

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <div className="w-full flex ">
      {!isMobile && (
        <div className="w-[300px] h-full px-3 flex flex-col gap-5 mt-5">
          <div className="w-full flex justify-center items-center">
            <Input
              variant="filled"
              radius="xl"
              w="100%"
              className="w-full "
              placeholder="Search for a branch"
              leftSection={<IconSearch color={"gray"} />}
            />
          </div>
          {isRestaurantsLoading ? (
            <div className="flex gap-5 flex-col ">
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  className="flex flex-col gap-3 p-2 border border-gray-200 rounded-lg"
                >
                  <Skeleton height={120} radius="md" width={"100%"} />
                  <Skeleton height={20} radius="sm" width={200} />
                  <Skeleton height={15} radius="sm" width={150} />
                  <Skeleton height={15} radius="sm" width={100} />
                </div>
              ))}
            </div>
          ) : (
            <div className="h-[calc(100vh-160px)] overflow-y-auto hideScrollBar">
              {restaurants?.items?.length === 0 && (
                <div className="text-center text-gray-500">
                  No branches found around you
                </div>
              )}
              <div className="flex gap-5 flex-col pb-20">
                {restaurants?.items?.map((restaurant: any) => (
                  <BranchCard key={restaurant.id} branch={restaurant} />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      <div className="w-full h-[calc(100vh-67px)]">
        <MapComponent branches={restaurants?.items} />
        {isMobile && (
          <div className="w-full h-[260px] fixed bottom-0 overflow-x-auto hideScrollBar">
            <div className="flex flex-row gap-5 p-4">
              {restaurants?.items?.map((restaurant: any) => (
                <div key={restaurant.id} className="w-[250px] shrink-0">
                  <BranchCard key={restaurant.id} branch={restaurant} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
